module.exports = __webpack_public_path__ + "img/sponsorL10.1318f368.png";